export const createUiSlice = (set) => ({
  receiptPreviewOpen: false,
  receiptPreviewMode: 'Receipt',

  setReceiptPreviewOpen: (isOpen) => set({ receiptPreviewOpen: isOpen }),
  setReceiptPreviewMode: (mode) => set({ receiptPreviewMode: mode })
});
